export default "__VITE_PUBLIC_ASSET__ae65dd48__"